import React from 'react';
import { Card, Typography, Avatar, Space, Divider, Button, Row, Col } from 'antd';
import { 
    UserOutlined, 
    MailOutlined, 
    GlobalOutlined, 
    GithubOutlined, 
    LinkedinOutlined,
    PhoneOutlined,
    MobileOutlined  
} from '@ant-design/icons';

import almaslogo from '../../assets/img/AlmasIcon256.png'
const { Title, Text, Paragraph } = Typography;

export const DeveloperInfo = ({ setLoading, showMessage, supportLinks }) => {
    return (
        <div style={{ padding: 24 }}>
            <Card>
                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <Row align="middle" gutter={[24, 24]}>
                        <Col>
                            <Avatar 
                                size={100} 
                                src={<img src={almaslogo} alt="لوگو" />}
                    style={{ backgroundColor: 'transparent' }}
                                // icon={<UserOutlined />}
                                // style={{ backgroundColor: '#1890ff' }}
                            />
                        </Col>
                        <Col flex="auto">
                            <Title level={3}>تهیه‌کننده برنامه</Title>
                            <Text strong>گروه نرم افزاری الماس اسپادانا</Text>
                            <br />
                            <Text type="secondary">تخصص در توسعه نرم افزارهای مالی و صنعتی و راه‌حل‌های نرم‌افزاری جهت نرم افزارهای تخصصی سفارش مشتری</Text>
                        </Col>
                    </Row>
                    
                    <Divider />
                    
                    <Title level={4}>درباره ما</Title>
                    <Paragraph>
                        شرکت ما با بیش از 24 سال سابقه در زمینه توسعه نرم‌افزارهای تخصصی مالی ، صنعتی و سفارش خاص
                        مفتخر است که این سامانه جامع را با آخرین تکنولوژی‌های روز دنیا طراحی و پیاده‌سازی کرده‌ایم.
                    </Paragraph>
                    
                    <Title level={4}>ارتباط با ما</Title>
                    <Space direction="vertical" style={{ width: '100%' }}>
                        <Button 
                            icon={<GlobalOutlined />} 
                            onClick={() => window.open(supportLinks.website, '_blank')}
                            block
                            style={{ textAlign: 'right' }}
                        >
                            وب‌سایت: {supportLinks.website}
                        </Button>
                        <Button 
                            icon={<MailOutlined />} 
                            onClick={() => window.open(`mailto:${supportLinks.email}`, '_blank')}
                            block
                            style={{ textAlign: 'right' }}
                        >
                            ایمیل: {supportLinks.email}
                        </Button>
                        <Button 
                            icon={<PhoneOutlined  />} 
                            onClick={() => window.open(supportLinks.website, '_blank')}
                            block
                            style={{ textAlign: 'right' }}
                        >
                            تلفن پشتیبانی: {supportLinks.phone}
                        </Button>
                        <Button 
                            icon={<MobileOutlined  />} 
                            onClick={() => window.open(supportLinks.website, '_blank')}
                            block
                            style={{ textAlign: 'right' }}
                        >
                            شماره همراه: {supportLinks.mobile}
                        </Button>
                        <Button 
                            icon={<GithubOutlined />} 
                            onClick={() => window.open(supportLinks.github, '_blank')}
                            block
                            style={{ textAlign: 'right' }}
                        >
                            GitHub: {supportLinks.github}
                        </Button>
                        <Button 
                            icon={<LinkedinOutlined />} 
                            onClick={() => window.open(supportLinks.linkedin, '_blank')}
                            block
                            style={{ textAlign: 'right' }}
                        >
                            LinkedIn: {supportLinks.linkedin}
                        </Button>
                    </Space>
                    
                    <Divider />
                    
                    <Title level={4}>سایر محصولات</Title>
                    <Paragraph>
                        • نرم افزارهای مدیریت مالی فروشگاهی الماس<br />
                        • سامانه های جامع مدیریت مالی ، برنامه ریزی و کنترل تولید کارخانجات صنعتی <br />
                        • سامانه داشبورد مدیریتی تحت وب نگاه - تحلیل داده و هوش تجاری (BI)<br />
                        • سامانه فرم ساز تحت وب رز<br />
                        • سامانه مدیریت رزرو و پذیرش اتاق در حسینیه (مشهد مقدس)<br />
                        • سامانه های تخصصی سفارش مشتری<br />
                    </Paragraph>
                </Space>
            </Card>
        </div>
    );
};